import {Component, Vue} from "vue-property-decorator"
import {delNullProperty} from '@/utils/index'
import {formatDate} from '@/utils/timeFilter'
import {UserModule} from "@/store/modules/user";
import {getCustomerConversionFollowList, getCustomerConversionFollowListExport} from "@/api/customer";
import { menuBtn } from '@/utils/menu_level2_button'
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";

@Component({
  components:{
    MoreUsersFilter
  }
})
export default class OrderStatisticsData extends Vue {
  page = 1
  limit = 20
  total = 0
  tableData = []
  tableLoading = false
  popover1 = false
  popover2 = false
  popover3 = false
  exportButtonDisabled = false
  exportHeaderDialogVisible = false
  tableHeader: any = [
    { filds: 'customerConversionName', cnFilds: '客户名称', isShow: true, id: 1 },
    { filds: 'userRealName', cnFilds: '跟进人', isShow: true, id: 2 },
    { filds: 'status', cnFilds: '状态', isShow: true, id: 3 },
    { filds: 'createdAt', cnFilds: '跟进时间', isShow: true, id: 4 },
    { filds: 'isHaveRegisterInfo', cnFilds: '提交报名信息', isShow: true, id: 5 },
    { filds: 'isHaveProject', cnFilds: '确定项目', isShow: true, id: 6 },
    { filds: 'isSolveSelect', cnFilds: '解决卡点', isShow: true, id: 7 },
    { filds: 'intentionality', cnFilds: '客户意向度', isShow: true, id: 8 },
    { filds: 'selectNameList', cnFilds: '卡点原因', isShow: true, id: 9 },
    { filds: 'haveFinanceContract', cnFilds: '存在十天内的合同', isShow: true, id: 10 },
    { filds: 'content', cnFilds: '跟进内容', isShow: true, id: 11 },
    { filds: 'customerConversionFollowDataList', cnFilds: '相关资料', isShow: true, id: 12 },
    { filds: 'level2DepartmentId', cnFilds: '跟进人所属二级部门', isShow: true, id: 13 },
  ]
  createdAt = [] // 跟进时间
  customerConversionName = ''
  userIdList = []
  intentionality = ''
  intentionalityList =  [
    {label:'A',value:'A',interpretation:'（7天内签约）'},
    {label:'B',value:'B',interpretation:'（15天内签约）'},
    {label:'C',value:'C',interpretation:'（30天内签约）'},
    {label:'D',value:'D',interpretation:'（90天内签约）'},
    {label:'E',value:'E',interpretation:'（长期跟进）'},
    {label:'F',value:'F',interpretation:'（流失并调入公海）'},
    {label:'已签约',value:'已签约',interpretation:''},
  ]
  menuBtn = menuBtn
  timer = null
  level2DepartmentList = [
    {name: '北京咨询部', id: 1047},
    {name: '上海咨询部', id: 1048},
    {name: '深圳咨询部', id: 1049},
    {name: '成都咨询部', id: 1065},
    {name: '广州咨询部', id: 1143},
    {name: '苏州咨询部', id: 1146}
  ]
  filterLevel2DepartmentId = ''
  isHaveRegisterInfo = ''
  isHaveProject = ''
  isSolveSelect = ''
  haveFinanceContract = ''
  created() {
    this.getTableData()
  }

  // 时间区间过滤器
  changeTime(val: Date[]): string {
    if (val == null) return ''
    let time = ''
    val.forEach((item: any) => {
      time += formatDate('yyyy-MM-dd', new Date(item)) + '&'
    })
    time = time.slice(0, time.length - 1)
    return time
  }
  //backMoneyAt: this.changeTime(this.backMoneyAt as Date[]), //回款时间


  async getTableData() {
    this.popover1 = false
    this.popover2 = false
    this.popover3 = false
    this.tableLoading = true
    try {
      const { allNum, customerConversionFollowList } = await getCustomerConversionFollowList(delNullProperty({
        customerConversionName: this.customerConversionName,
        userIdList: this.userIdList,
        createdAt: this.changeTime(this.createdAt),
        intentionality: this.intentionality,
        level2DepartmentId: this.filterLevel2DepartmentId,
        isHaveRegisterInfo: this.isHaveRegisterInfo,
        isHaveProject: this.isHaveProject,
        isSolveSelect: this.isSolveSelect,
        haveFinanceContract: this.haveFinanceContract === '是' ? true : this.haveFinanceContract === '否'? false: '',
        limit: this.limit,
        page: this.page,
      })) as unknown as { allNum: number; customerConversionFollowList: any[] }
      this.tableData = customerConversionFollowList
      this.total = allNum
      this.tableLoading = false
    } catch (error) {
      this.tableLoading = false
    }
  }

  async exportExcel(keys: string = '') {
    this.exportButtonDisabled = true
    await getCustomerConversionFollowListExport(delNullProperty({
          customerConversionName: this.customerConversionName,
          userIdList: this.userIdList,
          createdAt: this.changeTime(this.createdAt),
          intentionality: this.intentionality,
          level2DepartmentId: this.filterLevel2DepartmentId,
          isHaveRegisterInfo: this.isHaveRegisterInfo,
          isHaveProject: this.isHaveProject,
          isSolveSelect: this.isSolveSelect,
          haveFinanceContract:  this.haveFinanceContract === '是' ? true : this.haveFinanceContract === '否'? false: '',
          keys,
        })
    ).then(()=>{
      this.$message.success('数据已转入后台导出, 请前往下载列表查看')
    }).finally(() => {
      this.exportButtonDisabled = false
    })
  }

  pageSizeChange(limit: number) {
    this.limit = limit
    this.getTableData()
  }

  pageChange(page: number) {
    if (this.timer !== null) clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.page = page
      this.getTableData()
    }, 1000)
  }

  changeUsers(e){
    this.userIdList = e.id
    this.page = 1
    this.getTableData()
  }

  ClickTableRow(row: any, col: any) {
    if (!this.menuBtn(34)) return
    if (col.label !== '操作') {
      const win = window.open(window.location.origin + this.$route.matched[0].path + '/transfromCustomerEdit?id=' + row.customerConversionId + '&isEdit=0')
      const time = setInterval(() => {
        if (win.closed) {
          this.getTableData()
          clearInterval(time)
        }
      }, 500)
    }
  }

  handleScan(row: any) {
    const win = window.open(window.location.origin + this.$route.matched[0].path + '/transfromCustomerEdit?id=' + row.customerConversionId + '&isEdit=0')
    const time = setInterval(() => {
      if (win.closed) {
        this.getTableData()
        clearInterval(time)
      }
    }, 500)
  }
}
